import { useSelector } from 'react-redux';

const useCurrentUser = () => {
  const user = useSelector(state => state.general.user);
  return {
    ...user,
    isAdmin: user?.role === 'admin',
  };
};

export default useCurrentUser;
